// extracted by mini-css-extract-plugin
export default {"inviteHeadTitle":"auth__inviteHeadTitle__DczFhL","topPadding":"auth__topPadding__mna0I0"};